import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../spinners/SpinnerBars.vue.js';

/**
 * @deprecated Use SdsButton or SdsButtonText instead
 */
var script = defineComponent({
    props: {
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDisabledRed: {
            type: Boolean,
            required: false,
            default: false,
        },
        isBlockButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPrimaryYellow: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPrimaryGreen: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPrimaryDark: {
            type: Boolean,
            required: false,
            default: false,
        },
        isOutlineWhite: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        disableOnLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        iconPlacement: {
            type: String,
            required: false,
            default: '',
        },
        theme: {
            type: String,
            required: false,
            default: '',
        },
        size: {
            type: String,
            required: false,
            default: '',
        },
        type: {
            type: String,
            required: false,
            default: 'submit',
        },
    },
    computed: {
        shouldDisable: function () {
            return this.disabled || (this.isLoading && this.disableOnLoading);
        },
    },
    components: {
        SpinnerBars: __vue_component__,
    }
});

export default script;
